/**
 * This file contains Post message types that are sent to React Native Webview.
 */
export const WEBVIEW_EDIT_EVENT_SUCCESS = 'EDIT_EVENT_SUCCESS';
export const WEBVIEW_CREATE_EVENT_SUCCESS = 'CREATE_EVENT_SUCCESS';
export const WEBVIEW_DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS';

export const WEBVIEW_VIEW_EVENT = 'VIEW_EVENT';

export const WEBVIEW_CREATE_EVENT_ERROR = 'CREATE_EVENT_ERROR';
export const WEBVIEW_CLOSE = 'WEBVIEW_CLOSE';

export const WEBVIEW_APPROVE_EVENT_SUCCESS = 'APPROVE_EVENT_SUCCESS';

export const WEBVIEW_JOIN_ORGANIZATION_SUCCESS = 'JOIN_ORGANIZATION_SUCCESS';
export const WEBVIEW_JOIN_ASSOCIATION_SUCCESS = 'JOIN_ASSOCIATION_SUCCESS';
